<template src="./index.html"></template>
<script>
import minhead from '../../../../common/minHead/index.vue';
import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue';
import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue';
import { getdata } from './data.js';
import config from '../../../../../../configHttp.js';
import uploadFile from '../../../../common/uploadFile/index.vue';
import uploadFileplus from '../../../../common/uploadFileplus/index.vue';
import {
	querycell,
	writesave,
	startShenBao,
	forShengcdg,
	manuscriptqueryReportStep,
	manuscriptwriteimport,
	manuscriptUploadFile,
	annexadd
} from '../../../../../api/Draftgeneration.js';
import { querytemplatecell, getShuibDetailList, templatecellsave } from '../../../../../api/bbmb.js';
import { reportquerytrack } from '../../../../../api/xggj.js';
import { zcfg_fycx, zcfg_fetch } from '../../../../../api/zcfg.js';
import addzc from '../../../../common/addzc/index.vue';
import seezc from '../../../../common/seezc/index.vue';
import SmallScaleVAT_I from './SmallScaleVAT_I/index.vue';
import { getdata as dataI } from './SmallScaleVAT_I/data.js';
import SmallScaleVAT_II from './SmallScaleVAT_II/index.vue';
import { getdata as dataII } from './SmallScaleVAT_II/data.js';
import SmallScaleVAT_III from './SmallScaleVAT_III/index.vue';
import { getdata as dataIII } from './SmallScaleVAT_III/data.js';
import SmallScaleVAT_VI from './SmallScaleVAT_VI/index.vue';
import { getdata as dataVI } from './SmallScaleVAT_VI/data.js';
import SmallScaleVAT_V from './SmallScaleVAT_V/index.vue';
import { getdata as dataV } from './SmallScaleVAT_V/data.js';
export default {
	name: '',
	components: {
		minhead,
		SalesTaxReportTree,
		SalesTaxReportbox,
		uploadFile,
		uploadFileplus,
		addzc,
		seezc,
		SmallScaleVAT_I,
		SmallScaleVAT_II,
		SmallScaleVAT_III,
		SmallScaleVAT_VI,
		SmallScaleVAT_V
	},
	props: {
		seeNow: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: ''
		},
		params: {
			type: Object,
			default: {}
		},
		suosq: {
			type: String,
			default: ''
		},
		sbqj: {
			type: String,
			default: ''
		},
		showbox: {
			type: Boolean,
			default: false
		},
		mintext: {
			type: String,
			default: '填写'
		},
		toseeUpdate: {
			type: Boolean,
			default: false
		}
	},

	mounted() {
		if (this.toseeUpdate) {
			this.getShuibDetailList();
		} else {
			this.manuscriptqueryReportStep();
		}
	},
	data: function() {
		return {
			Changed:0,
			treestate: '',
			statedata: [],
			treedata: getdata().treedata,
			choosetitleindex: '',
			formlist: getdata().formlist,
			headobj: {},
			choosecellCode: '',
			smtext: '',
			zcdata: [],
			searchlistzc: getdata().searchlistzc,
			headDatazc: getdata().headDatazc,
			pagination: getdata().pagination,
			seezcformlist: getdata().seezcformlist,
			formdatazc: getdata().formdatazc, //form表单数据
			tableDataIx: [],
			tableDataI: [],
			tableDataIII: [],
			tableDataVI: [],
			tableDataci: [],
			ZeroHead: ['cwbbxqykjzz_0_x_1', 'cwbbxqykjzz_0_x_2'],
			IHead: ['cwbbxqykjzz_1_x_1', 'cwbbxqykjzz_1_x_2'],
			IIHead: ['cwbbxqykjzz_2_x_1', 'cwbbxqykjzz_2_x_2'],
			IIIHead: ['cwbbxqykjzz_3_x_1', 'cwbbxqykjzz_3_x_2'],
			IVHead: ['cwbbxqykjzz_4_x_1', 'cwbbxqykjzz_4_x_2'],
			choosetable: '',
			chooseindex: '',
			choosecolum: ''
		};
	},

	methods: {
		//政策点击预览
		zcsclick(id) {
			this.$refs.boxref.zcsclick(id);
		},
		//选中格子
		forhover(table, colum, index) {
			this.$refs.boxref.forhover(table, colum, index);
		},
		//获取选中格子
		getchoosecellCode(table, colum, index) {
			if (this.$emptyandnull(table)) {
				this.choosecellCode = '';
				return false;
			}
			this.choosetable = table;
			this.chooseindex = index;
			this.choosecolum = colum;
			this.choosecellCode = this[table][index][colum].cellCode;
			if (this.toseeUpdate) {
				this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : '';
				this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : [];
			} else {
				this.smtext = this[table][index][colum]['updateDesc'] || '';
			}
		},
		//更正说明
		forgengzheng(table, colum, index, smtext) {
			console.log(this[table][index][colum])
			this[table][index][colum]['updateDesc'] = smtext;
		},
		//更正政策和说明
		forxzsm(table, colum, index, smtext, zcdata) {
			this[table][index][colum]['map'] = {
				desc: '',
				zcs: []
			};
			this[table][index][colum]['map']['desc'] = smtext;
			this[table][index][colum]['map']['zcs'] = zcdata;
		},
		//点击全部范围
		refreshhover() {
			this.$nextTick(() => {
				this.$refs.boxref.refreshhover();
			});
		},
		getShuibDetailList() {
			getShuibDetailList({
				szId: this.params.szId,
				id: this.params.id
			}).then(res => {
				if (res.data.code == 1) {
					this.treedata = res.data.data.detail;
					if (this.treedata[0]) {
						this.getchoosetitleindex(this.treedata[0]);
					}
					this.querycell();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		manuscriptqueryReportStep() {
			manuscriptqueryReportStep({
				id: this.params.id,
				sbbm: this.params.sbbm
			}).then(res => {
				if (res.data.code == 1) {
					this.statedata = res.data.data.statusHistory;
					this.treedata = res.data.data.detail;
					if (this.treedata[0]) {
						this.getchoosetitleindex(this.treedata[0]);
					}
					this.querycell();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		getchoosetitleindex(item) {
			this.choosetitleindex = item.shuibNameCode;
		},
		//表格隐藏显示和返回
		forback() {
			if(this.Changed>0){
					this.$showConfirm({
						message: "是否不保存当前修改?",
						title:"您还未保存",
					}).then((res) => {
						if (res == "confirm") {
							this.$emit('forback', true);
						}else{
							//取消
						}
					});
			}else{
				this.$emit('forback', true);
			}
		},
		changestate(e) {
			this.treestate = e;
		},
		//传给后端值处理
		filternums(data, filterlist) {
			var newlist = [];
			filterlist.forEach(ytem => {
				let newval = data.map(item => {
					if (item[ytem] != undefined && item[ytem] != 'undefined' && this.$notemptyandnull(item[ytem] && item[ytem].cellVal != null)) {
						return item[ytem];
					} else {
						return 'x';
					}
				});
				newlist = [...newlist, ...newval].filter(gtem => gtem != 'x');
			});
			return newlist;
		},
		//本栏开始替换
		//重置主表
		refreshtableDataZero() {
			this.tableDataI.forEach((item, index) => {
				this.ZeroHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '0';
					}
				});
			});
			this.tableDataci.forEach((item, index) => {
				this.ZeroHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '0';
					}
				});
			});
		},
		//重置附表一
		refreshtableDataI() {
			this.tableDataII.forEach((item, index) => {
				this.IHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '0';
					}
				});
			});
		},
		//重置附表二
		refreshtableDataII() {
			this.tableDataIII.forEach((item, index) => {
				this.IIHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '0';
					}
				});
			});
		},
		//重置附表三
		refreshtableDataIII() {
			this.tableDataV.forEach((item, index) => {
				this.IIIHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '0';
					}
				});
			});
		},
		//重置附表四
		refreshtableDataIV() {
			this.tableDataVI.forEach((item, index) => {
				this.IVHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '0';
					}
				});
			});
		},
		commanddcrefresh(e) {
				this.Changed++
			if (e == 'now') {
				if (this.choosetitleindex == 'cwbbxqykjzz_0') {
					this.refreshtableDataZero();
				}
				if (this.choosetitleindex == 'cwbbxqykjzz_1') {
					this.refreshtableDataI();
				}
				if (this.choosetitleindex == 'cwbbxqykjzz_2') {
					this.refreshtableDataII();
				}
				if (this.choosetitleindex == 'cwbbxqykjzz_3') {
					this.refreshtableDataIII();
				}
				if (this.choosetitleindex == 'cwbbxqykjzz_4') {
					this.refreshtableDataIV();
				}
			}
			if (e == 'all') {
				Object.keys(this.headobj).map(key => (this.headobj[key] = ''));
				this.refreshtableDataZero();
				this.refreshtableDataI();
				this.refreshtableDataII();
				this.refreshtableDataIII();
				this.refreshtableDataIV();
			}
		},
		//所有表格渲染
		querycell(index) {
			//编辑格子查询

			if (this.type == 'update') {
				querycell({
					companyNo: this.params.companyNo, // 公司编号
					id: this.params.id, //报表id
					shuibId: this.params.shuibId, //税种id
					sbbm: this.params.sbbm
				}).then(res => {
					let dataarr = res.data.data;
					this.gettable(dataarr);
				});
			}
			if (this.type == 'tosee') {
				if (this.seeNow) {
					querycell({
						companyNo: this.params.companyNo, // 公司编号
						id: this.params.id, //报表id
						shuibId: this.params.shuibId, //税种id
						sbbm: this.params.sbbm
					}).then(res => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
					return false;
				}
				if (this.toseeUpdate) {
					querytemplatecell({
						shuibId: this.params.id,
						id: this.params.id
					}).then(res => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
				} else {
					reportquerytrack({
						companyNo: this.params.companyNo, // 公司编号
						id: this.params.id, //报表id
						shuibId: this.params.shuibId, //税种id
						sbbm: this.params.sbbm,
						trackId: this.params.trackId
					}).then(res => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
				}
			}
		},
		gettable(dataarr) {
			this.headobj = dataarr.head;
			if (dataarr.cwbbxqykjzz_0) {
				dataarr.cwbbxqykjzz_0.splice(15, 0, {
					cwbbxqykjzz_0_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_0_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_0.splice(42, 0, {
					cwbbxqykjzz_0_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_0_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_0.splice(49, 0, {
					cwbbxqykjzz_0_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_0_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_0.splice(50, 0, {
					cwbbxqykjzz_0_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_0_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_0.splice(51, 0, {
					cwbbxqykjzz_0_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_0_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_0.splice(52, 0, {
					cwbbxqykjzz_0_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_0_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_0.splice(53, 0, {
					cwbbxqykjzz_0_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_0_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_0.splice(54, 0, {
					cwbbxqykjzz_0_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_0_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_0.splice(55, 0, {
					cwbbxqykjzz_0_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_0_x_2: {
						cellType: '0'
					}
				});
			}
			if (dataarr.cwbbxqykjzz_1) {
				dataarr.cwbbxqykjzz_1.splice(0, 0, {
					cwbbxqykjzz_1_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_1_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_1.splice(8, 0, {
					cwbbxqykjzz_1_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_1_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_1.splice(15, 0, {
					cwbbxqykjzz_1_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_1_x_2: {
						cellType: '0'
					}
				});
			}
			if (dataarr.cwbbxqykjzz_3) {
				dataarr.cwbbxqykjzz_3.splice(0, 0, {
					cwbbxqykjzz_3_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_3_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_3.splice(8, 0, {
					cwbbxqykjzz_3_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_3_x_2: {
						cellType: '0'
					}
				});
				dataarr.cwbbxqykjzz_3.splice(15, 0, {
					cwbbxqykjzz_3_x_1: {
						cellType: '0'
					},
					cwbbxqykjzz_3_x_2: {
						cellType: '0'
					}
				});
			}

			//主表
			var newtabledataZero = dataarr.cwbbxqykjzz_0;
			var realtableDataout = newtabledataZero.filter((item, index) => index < 31);
			var realtableDataZero = dataI().tableData;
			realtableDataZero.forEach((item, index) => {
				if (newtabledataZero && realtableDataout[index]) {
					this.ZeroHead.forEach(gtem => {
						item[gtem] = realtableDataout[index][gtem];
					});
				}
			});
			this.tableDataI = realtableDataZero;
			var newtabledataV = newtabledataZero.filter((item, index) => index > 30);
			var realtableDataV = dataI().tableDatas;
			realtableDataV.forEach((item, index) => {
				if (newtabledataV && newtabledataV[index]) {
					this.ZeroHead.forEach(gtem => {
						item[gtem] = newtabledataV[index][gtem];
					});
				}
			});
			this.tableDataci = realtableDataV;
			//附表一
			var newtabledataI = dataarr.cwbbxqykjzz_1;
			var realtableDataI = dataII().tableData;
			realtableDataI.forEach((item, index) => {
				if (newtabledataI && newtabledataI[index]) {
					this.IHead.forEach(gtem => {
						item[gtem] = newtabledataI[index][gtem];
					});
				}
			});
			this.tableDataII = realtableDataI;
			//附表二
			var newtabledataII = dataarr.cwbbxqykjzz_2;
			var realtableDataII_I = dataIII().tableData;
			realtableDataII_I.forEach((item, index) => {
				if (newtabledataII && newtabledataII[index]) {
					this.IIHead.forEach(gtem => {
						item[gtem] = newtabledataII[index][gtem];
					});
				}
			});

			this.tableDataIII = realtableDataII_I;
			var newtabledataIII = dataarr.cwbbxqykjzz_4;
			var realtableDataIII = dataV().tableData;
			realtableDataIII.forEach((item, index) => {
				if (newtabledataIII && newtabledataIII[index]) {
					this.IVHead.forEach(gtem => {
						item[gtem] = newtabledataIII[index][gtem];
					});
				}
			});
			this.tableDataV = realtableDataIII;
			//附表四
			var newtabledataIV = dataarr.cwbbxqykjzz_3;
			var realtableDataIV_I = dataVI().tableData;
			realtableDataIV_I.forEach((item, index) => {
				if (newtabledataIV && newtabledataIV[index]) {
					this.IIIHead.forEach(gtem => {
						item[gtem] = newtabledataIV[index][gtem];
					});
				}
			});
			this.tableDataVI = realtableDataIV_I;
		},

		forsave() {
			const newarr = [
				...this.filternums(this.tableDataI, this.ZeroHead),
				...this.filternums(this.tableDataci, this.ZeroHead),
				...this.filternums(this.tableDataII, this.IHead),
				...this.filternums(this.tableDataIII, this.IIHead),
				...this.filternums(this.tableDataVI, this.IIIHead),
				...this.filternums(this.tableDataV, this.IVHead)
			];
			let params = {
				cells: newarr,
				companyNo: this.params.companyNo,
				id: this.params.id,
				sbbm: this.params.sbbm,
				head: this.headobj,
				checkFlag: true
			};
			writesave(params).then(res => {
				if (res.data.code == 1) {
					this.Changed = 0
					this.querycell();
					this.$message.success(res.data.msg);
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		inputblur(e) {
			this.Changed++
			if (
				parseFloat(e.cellVal).toFixed(2) != parseFloat(this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal']).toFixed(2) &&
				this[this.choosetable][this.chooseindex][this.choosecolum]['cellCode'] == e.cellCode
			) {
				this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
			}
			if (e.cellCode == 'cwbbxqykjzz_0_1_1') {
				this.cwbbxqykjzz_0_15_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_1_2') {
				this.cwbbxqykjzz_0_15_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_2_1') {
				this.cwbbxqykjzz_0_15_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_2_2') {
				this.cwbbxqykjzz_0_15_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_3_1') {
				this.cwbbxqykjzz_0_15_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_3_2') {
				this.cwbbxqykjzz_0_15_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_4_1') {
				this.cwbbxqykjzz_0_15_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_4_2') {
				this.cwbbxqykjzz_0_15_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_5_1') {
				this.cwbbxqykjzz_0_15_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_5_2') {
				this.cwbbxqykjzz_0_15_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_6_1') {
				this.cwbbxqykjzz_0_15_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_6_2') {
				this.cwbbxqykjzz_0_15_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_7_1') {
				this.cwbbxqykjzz_0_15_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_7_2') {
				this.cwbbxqykjzz_0_15_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_8_1') {
				this.cwbbxqykjzz_0_15_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_8_2') {
				this.cwbbxqykjzz_0_15_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_9_1') {
				this.cwbbxqykjzz_0_15_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_9_2') {
				this.cwbbxqykjzz_0_15_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_10_1') {
				this.changetableval(
					'cwbbxqykjzz_0_9_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_10_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_11_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_12_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_13_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_10_2') {
				this.changetableval(
					'cwbbxqykjzz_0_9_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_10_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_11_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_12_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_13_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_11_1') {
				this.changetableval(
					'cwbbxqykjzz_0_9_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_10_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_11_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_12_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_13_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_11_2') {
				this.changetableval(
					'cwbbxqykjzz_0_9_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_10_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_11_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_12_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_13_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_12_1') {
				this.changetableval(
					'cwbbxqykjzz_0_9_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_10_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_11_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_12_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_13_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_12_2') {
				this.changetableval(
					'cwbbxqykjzz_0_9_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_10_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_11_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_12_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_13_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_13_1') {
				this.changetableval(
					'cwbbxqykjzz_0_9_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_10_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_11_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_12_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_13_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_13_2') {
				this.changetableval(
					'cwbbxqykjzz_0_9_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_10_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_11_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_12_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_13_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_14_1') {
				this.cwbbxqykjzz_0_15_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_14_2') {
				this.cwbbxqykjzz_0_15_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_15_1') {
				this.changetableval(
					'cwbbxqykjzz_0_30_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_15_1', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_29_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_15_2') {
				this.changetableval(
					'cwbbxqykjzz_0_30_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_15_2', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_29_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_16_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_16_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_17_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_17_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_18_1') {
				this.changetableval(
					'cwbbxqykjzz_0_20_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_18_1', 'tableDataI') - this.gettableval('cwbbxqykjzz_0_19_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_18_2') {
				this.changetableval(
					'cwbbxqykjzz_0_20_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_18_2', 'tableDataI') - this.gettableval('cwbbxqykjzz_0_19_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_19_1') {
				tthis.changetableval(
					'cwbbxqykjzz_0_20_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_18_1', 'tableDataI') - this.gettableval('cwbbxqykjzz_0_19_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_19_2') {
				this.changetableval(
					'cwbbxqykjzz_0_20_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_18_2', 'tableDataI') - this.gettableval('cwbbxqykjzz_0_19_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_20_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_20_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_21_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_21_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_22_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_22_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_23_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_23_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_24_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_24_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_25_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_25_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_26_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_26_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_27_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_27_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_28_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_28_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_29_1') {
				this.changetableval(
					'cwbbxqykjzz_0_30_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_15_1', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_29_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_29_2') {
				this.changetableval(
					'cwbbxqykjzz_0_30_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_15_2', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_29_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_28_1') {
				this.cwbbxqykjzz_0_29_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_28_2') {
				this.cwbbxqykjzz_0_29_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_31_1') {
				this.cwbbxqykjzz_0_41_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_31_2') {
				this.cwbbxqykjzz_0_41_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_32_1') {
				this.cwbbxqykjzz_0_41_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_32_2') {
				this.cwbbxqykjzz_0_41_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_33_1') {
				this.cwbbxqykjzz_0_41_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_33_2') {
				this.cwbbxqykjzz_0_41_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_34_1') {
				this.cwbbxqykjzz_0_41_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_34_2') {
				this.cwbbxqykjzz_0_41_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_35_1') {
				this.cwbbxqykjzz_0_41_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_35_2') {
				this.cwbbxqykjzz_0_41_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_36_1') {
				this.cwbbxqykjzz_0_41_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_36_2') {
				this.cwbbxqykjzz_0_41_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_37_1') {
				this.cwbbxqykjzz_0_41_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_37_2') {
				this.cwbbxqykjzz_0_41_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_38_1') {
				this.cwbbxqykjzz_0_41_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_38_2') {
				this.cwbbxqykjzz_0_41_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_39_1') {
				this.cwbbxqykjzz_0_41_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_39_2') {
				this.cwbbxqykjzz_0_41_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_40_1') {
				this.cwbbxqykjzz_0_41_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_40_2') {
				this.cwbbxqykjzz_0_41_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_0_41_1') {
				this.changetableval(
					'cwbbxqykjzz_0_47_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_41_1', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_46_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_41_2') {
				this.changetableval(
					'cwbbxqykjzz_0_47_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_41_2', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_46_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_42_1') {
				this.changetableval(
					'cwbbxqykjzz_0_46_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_42_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_43_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_44_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_45_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_42_2') {
				this.changetableval(
					'cwbbxqykjzz_0_46_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_42_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_43_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_44_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_45_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_43_1') {
				this.changetableval(
					'cwbbxqykjzz_0_46_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_42_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_43_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_44_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_45_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_43_2') {
				this.changetableval(
					'cwbbxqykjzz_0_46_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_42_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_43_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_44_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_45_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_44_1') {
				this.changetableval(
					'cwbbxqykjzz_0_46_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_42_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_43_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_44_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_45_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_44_2') {
				this.changetableval(
					'cwbbxqykjzz_0_46_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_42_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_43_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_44_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_45_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_45_1') {
				this.changetableval(
					'cwbbxqykjzz_0_46_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_42_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_43_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_44_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_45_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_45_2') {
				this.changetableval(
					'cwbbxqykjzz_0_46_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_42_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_43_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_44_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_45_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_46_1') {
				this.changetableval(
					'cwbbxqykjzz_0_47_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_41_1', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_46_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_46_2') {
				this.changetableval(
					'cwbbxqykjzz_0_47_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_41_2', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_46_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_47_1') {
				this.changetableval(
					'cwbbxqykjzz_0_53_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_47_1', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_52_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_47_2') {
				this.changetableval(
					'cwbbxqykjzz_0_53_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_47_2', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_52_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_48_1') {
				this.changetableval(
					'cwbbxqykjzz_0_52_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_48_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_49_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_50_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_51_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_48_2') {
				this.changetableval(
					'cwbbxqykjzz_0_52_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_48_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_49_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_50_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_51_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_49_1') {
				this.changetableval(
					'cwbbxqykjzz_0_52_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_48_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_49_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_50_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_51_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_49_2') {
				this.changetableval(
					'cwbbxqykjzz_0_52_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_48_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_49_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_50_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_51_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_50_1') {
				this.changetableval(
					'cwbbxqykjzz_0_52_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_48_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_49_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_50_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_51_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_50_2') {
				this.changetableval(
					'cwbbxqykjzz_0_52_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_48_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_49_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_50_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_51_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_51_1') {
				this.changetableval(
					'cwbbxqykjzz_0_52_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_48_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_49_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_50_1', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_51_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_51_2') {
				this.changetableval(
					'cwbbxqykjzz_0_52_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_48_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_49_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_50_2', 'tableDataI') +
						this.gettableval('cwbbxqykjzz_0_51_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_52_1') {
				this.changetableval(
					'cwbbxqykjzz_0_53_1',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_47_1', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_52_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_0_52_2') {
				this.changetableval(
					'cwbbxqykjzz_0_53_2',
					'tableDataI',
					this.gettableval('cwbbxqykjzz_0_47_2', 'tableDataI') + this.gettableval('cwbbxqykjzz_0_52_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_1_1') {
				this.cwbbxqykjzz_1_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_2_1') {
				this.cwbbxqykjzz_1_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_3_1') {
				this.cwbbxqykjzz_1_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_4_1') {
				this.cwbbxqykjzz_1_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_5_1') {
				this.cwbbxqykjzz_1_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_6_1') {
				this.cwbbxqykjzz_1_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_1_2') {
				this.cwbbxqykjzz_1_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_2_2') {
				this.cwbbxqykjzz_1_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_3_2') {
				this.cwbbxqykjzz_1_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_4_2') {
				this.cwbbxqykjzz_1_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_5_2') {
				this.cwbbxqykjzz_1_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_6_2') {
				this.cwbbxqykjzz_1_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_7_1') {
				this.changetableval(
					'cwbbxqykjzz_1_20_1',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_7_1', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_13_1', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_19_1', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_7_2') {
				this.changetableval(
					'cwbbxqykjzz_1_20_2',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_7_2', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_13_2', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_19_2', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_8_1') {
				this.cwbbxqykjzz_1_13_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_9_1') {
				this.cwbbxqykjzz_1_13_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_10_1') {
				this.cwbbxqykjzz_1_13_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_11_1') {
				this.cwbbxqykjzz_1_13_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_12_1') {
				this.cwbbxqykjzz_1_13_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_8_2') {
				this.cwbbxqykjzz_1_13_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_9_2') {
				this.cwbbxqykjzz_1_13_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_10_2') {
				this.cwbbxqykjzz_1_13_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_11_2') {
				this.cwbbxqykjzz_1_13_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_12_2') {
				this.cwbbxqykjzz_1_13_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_1_13_1') {
				this.changetableval(
					'cwbbxqykjzz_1_20_1',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_7_1', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_13_1', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_19_1', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_13_2') {
				this.changetableval(
					'cwbbxqykjzz_1_20_2',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_7_2', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_13_2', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_19_2', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_14_1') {
				this.changetableval(
					'cwbbxqykjzz_1_19_1',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_14_1', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_15_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_16_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_17_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_18_1', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_14_2') {
				this.changetableval(
					'cwbbxqykjzz_1_19_2',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_14_2', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_15_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_16_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_17_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_18_2', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_15_1') {
				this.changetableval(
					'cwbbxqykjzz_1_19_1',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_14_1', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_15_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_16_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_17_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_18_1', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_15_2') {
				this.changetableval(
					'cwbbxqykjzz_1_19_2',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_14_2', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_15_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_16_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_17_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_18_2', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_16_1') {
				this.changetableval(
					'cwbbxqykjzz_1_19_1',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_14_1', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_15_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_16_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_17_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_18_1', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_16_2') {
				this.changetableval(
					'cwbbxqykjzz_1_19_2',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_14_2', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_15_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_16_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_17_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_18_2', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_17_1') {
				this.changetableval(
					'cwbbxqykjzz_1_19_1',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_14_1', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_15_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_16_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_17_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_18_1', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_17_2') {
				this.changetableval(
					'cwbbxqykjzz_1_19_2',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_14_2', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_15_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_16_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_17_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_18_2', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_18_1') {
				this.changetableval(
					'cwbbxqykjzz_1_19_1',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_14_1', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_15_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_16_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_17_1', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_18_1', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_18_2') {
				this.changetableval(
					'cwbbxqykjzz_1_19_2',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_14_2', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_15_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_16_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_17_2', 'tableDataII') -
						this.gettableval('cwbbxqykjzz_1_18_2', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_19_1') {
				this.changetableval(
					'cwbbxqykjzz_1_20_1',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_7_1', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_13_1', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_19_1', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_19_2') {
				this.changetableval(
					'cwbbxqykjzz_1_20_2',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_7_2', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_13_2', 'tableDataII') +
						this.gettableval('cwbbxqykjzz_1_19_2', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_20_1') {
				this.changetableval(
					'cwbbxqykjzz_1_22_1',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_20_1', 'tableDataII') + this.gettableval('cwbbxqykjzz_1_21_1', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_20_2') {
				this.changetableval(
					'cwbbxqykjzz_1_22_2',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_20_2', 'tableDataII') + this.gettableval('cwbbxqykjzz_1_21_2', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_21_1') {
				this.changetableval(
					'cwbbxqykjzz_1_22_1',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_20_1', 'tableDataII') + this.gettableval('cwbbxqykjzz_1_21_1', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_1_21_2') {
				this.changetableval(
					'cwbbxqykjzz_1_22_2',
					'tableDataII',
					this.gettableval('cwbbxqykjzz_1_20_2', 'tableDataII') + this.gettableval('cwbbxqykjzz_1_21_2', 'tableDataII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_1_1') {
				this.cwbbxqykjzz_2_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_1_2') {
				this.cwbbxqykjzz_2_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_2_1') {
				this.cwbbxqykjzz_2_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_2_2') {
				this.cwbbxqykjzz_2_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_3_1') {
				this.cwbbxqykjzz_2_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_3_2') {
				this.cwbbxqykjzz_2_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_4_1') {
				this.cwbbxqykjzz_2_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_4_2') {
				this.cwbbxqykjzz_2_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_5_1') {
				this.cwbbxqykjzz_2_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_5_2') {
				this.cwbbxqykjzz_2_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_6_1') {
				this.cwbbxqykjzz_2_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_6_2') {
				this.cwbbxqykjzz_2_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_7_1') {
				this.cwbbxqykjzz_2_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_7_2') {
				this.cwbbxqykjzz_2_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_8_1') {
				this.cwbbxqykjzz_2_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_8_2') {
				this.cwbbxqykjzz_2_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_9_1') {
				this.cwbbxqykjzz_2_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_9_2') {
				this.cwbbxqykjzz_2_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_10_1') {
				this.cwbbxqykjzz_2_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_10_2') {
				this.cwbbxqykjzz_2_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_11_1') {
				this.cwbbxqykjzz_2_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_11_2') {
				this.cwbbxqykjzz_2_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_12_1') {
				this.changetableval(
					'cwbbxqykjzz_2_11_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_12_1', 'tableDataIII') + this.gettableval('cwbbxqykjzz_2_13_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_12_2') {
				this.changetableval(
					'cwbbxqykjzz_2_11_2',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_12_2', 'tableDataIII') + this.gettableval('cwbbxqykjzz_2_13_2', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_13_1') {
				this.changetableval(
					'cwbbxqykjzz_2_11_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_12_1', 'tableDataIII') + this.gettableval('cwbbxqykjzz_2_13_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_13_2') {
				this.changetableval(
					'cwbbxqykjzz_2_11_2',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_12_2', 'tableDataIII') + this.gettableval('cwbbxqykjzz_2_13_2', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_14_1') {
				this.cwbbxqykjzz_2_21_1();
				this.cwbbxqykjzz_2_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_14_2') {
				this.cwbbxqykjzz_2_21_1();
				this.cwbbxqykjzz_2_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_15_1') {
				this.changetableval(
					'cwbbxqykjzz_2_14_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_15_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_13_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_17_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_15_2') {
				this.changetableval(
					'cwbbxqykjzz_2_14_2',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_15_2', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_13_2', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_17_2', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_16_1') {
				this.changetableval(
					'cwbbxqykjzz_2_14_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_15_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_13_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_17_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_16_2') {
				this.changetableval(
					'cwbbxqykjzz_2_14_2',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_15_2', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_13_2', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_17_2', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_17_1') {
				this.changetableval(
					'cwbbxqykjzz_2_14_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_15_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_13_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_17_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_17_2') {
				this.changetableval(
					'cwbbxqykjzz_2_14_2',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_15_2', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_13_2', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_17_2', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_18_1') {
				this.cwbbxqykjzz_2_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_18_2') {
				this.cwbbxqykjzz_2_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_19_1') {
				this.changetableval('cwbbxqykjzz_2_18_1', 'tableDataIII', this.gettableval('cwbbxqykjzz_2_19_1', 'tableDataIII'));
			}
			if (e.cellCode == 'cwbbxqykjzz_2_19_2') {
				this.changetableval('cwbbxqykjzz_2_18_2', 'tableDataIII', this.gettableval('cwbbxqykjzz_2_19_2', 'tableDataIII'));
			}
			if (e.cellCode == 'cwbbxqykjzz_2_20_1') {
				this.cwbbxqykjzz_2_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_20_2') {
				this.cwbbxqykjzz_2_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_21_1') {
				this.changetableval(
					'cwbbxqykjzz_2_30_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_21_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_22_1', 'tableDataIII') -
						this.gettableval('cwbbxqykjzz_2_24_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_21_2') {
				this.changetableval(
					'cwbbxqykjzz_2_30_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_21_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_22_1', 'tableDataIII') -
						this.gettableval('cwbbxqykjzz_2_24_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_22_1') {
				this.changetableval(
					'cwbbxqykjzz_2_30_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_21_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_22_1', 'tableDataIII') -
						this.gettableval('cwbbxqykjzz_2_24_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_22_2') {
				this.changetableval(
					'cwbbxqykjzz_2_30_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_21_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_22_1', 'tableDataIII') -
						this.gettableval('cwbbxqykjzz_2_24_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_23_1') {
				this.changetableval('cwbbxqykjzz_2_22_1', 'tableDataIII', this.gettableval('cwbbxqykjzz_2_23_1', 'tableDataIII'));
			}
			if (e.cellCode == 'cwbbxqykjzz_2_23_2') {
				this.changetableval('cwbbxqykjzz_2_22_2', 'tableDataIII', this.gettableval('cwbbxqykjzz_2_23_2', 'tableDataIII'));
			}
			if (e.cellCode == 'cwbbxqykjzz_2_24_1') {
				this.changetableval(
					'cwbbxqykjzz_2_30_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_21_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_22_1', 'tableDataIII') -
						this.gettableval('cwbbxqykjzz_2_24_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_24_2') {
				this.changetableval(
					'cwbbxqykjzz_2_30_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_21_1', 'tableDataIII') +
						this.gettableval('cwbbxqykjzz_2_22_1', 'tableDataIII') -
						this.gettableval('cwbbxqykjzz_2_24_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_25_1') {
				this.cwbbxqykjzz_2_24_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_25_2') {
				this.cwbbxqykjzz_2_24_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_26_1') {
				this.cwbbxqykjzz_2_24_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_26_2') {
				this.cwbbxqykjzz_2_24_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_27_1') {
				this.cwbbxqykjzz_2_24_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_27_2') {
				this.cwbbxqykjzz_2_24_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_28_1') {
				this.cwbbxqykjzz_2_24_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_28_2') {
				this.cwbbxqykjzz_2_24_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_29_1') {
				this.cwbbxqykjzz_2_24_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_29_2') {
				this.cwbbxqykjzz_2_24_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_2_30_1') {
				this.changetableval(
					'cwbbxqykjzz_2_32_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_30_1', 'tableDataIII') - this.gettableval('cwbbxqykjzz_2_31_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_30_2') {
				this.changetableval(
					'cwbbxqykjzz_2_32_2',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_30_2', 'tableDataIII') - this.gettableval('cwbbxqykjzz_2_31_2', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_31_1') {
				this.changetableval(
					'cwbbxqykjzz_2_32_1',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_30_1', 'tableDataIII') - this.gettableval('cwbbxqykjzz_2_31_1', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_2_31_2') {
				this.changetableval(
					'cwbbxqykjzz_2_32_2',
					'tableDataIII',
					this.gettableval('cwbbxqykjzz_2_30_2', 'tableDataIII') - this.gettableval('cwbbxqykjzz_2_31_2', 'tableDataIII')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_1_1') {
				this.cwbbxqykjzz_3_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_1_2') {
				this.cwbbxqykjzz_3_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_2_1') {
				this.cwbbxqykjzz_3_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_2_2') {
				this.cwbbxqykjzz_3_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_3_1') {
				this.cwbbxqykjzz_3_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_3_2') {
				this.cwbbxqykjzz_3_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_4_1') {
				this.cwbbxqykjzz_3_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_4_2') {
				this.cwbbxqykjzz_3_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_5_1') {
				this.cwbbxqykjzz_3_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_5_2') {
				this.cwbbxqykjzz_3_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_6_1') {
				this.cwbbxqykjzz_3_7_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_6_2') {
				this.cwbbxqykjzz_3_7_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_3_7_1') {
				this.changetableval(
					'cwbbxqykjzz_3_20_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_7_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_13_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_19_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_7_2') {
				this.changetableval(
					'cwbbxqykjzz_3_20_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_7_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_13_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_19_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_8_1') {
				this.changetableval(
					'cwbbxqykjzz_3_13_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_8_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_8_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_10_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_11_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_12_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_8_2') {
				this.changetableval(
					'cwbbxqykjzz_3_13_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_8_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_8_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_10_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_11_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_12_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_9_1') {
				this.changetableval(
					'cwbbxqykjzz_3_13_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_8_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_8_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_10_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_11_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_12_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_9_2') {
				this.changetableval(
					'cwbbxqykjzz_3_13_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_8_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_8_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_10_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_11_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_12_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_10_1') {
				this.changetableval(
					'cwbbxqykjzz_3_13_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_8_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_8_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_10_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_11_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_12_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_10_2') {
				this.changetableval(
					'cwbbxqykjzz_3_13_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_8_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_8_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_10_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_11_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_12_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_11_1') {
				this.changetableval(
					'cwbbxqykjzz_3_13_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_8_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_8_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_10_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_11_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_12_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_11_2') {
				this.changetableval(
					'cwbbxqykjzz_3_13_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_8_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_8_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_10_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_11_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_12_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_12_1') {
				this.changetableval(
					'cwbbxqykjzz_3_13_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_8_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_8_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_10_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_11_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_12_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_12_2') {
				this.changetableval(
					'cwbbxqykjzz_3_13_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_8_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_8_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_10_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_11_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_12_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_13_1') {
				this.changetableval(
					'cwbbxqykjzz_3_20_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_7_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_13_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_19_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_13_2') {
				this.changetableval(
					'cwbbxqykjzz_3_20_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_7_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_13_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_19_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_14_1') {
				this.changetableval(
					'cwbbxqykjzz_3_19_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_14_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_15_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_16_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_17_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_18_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_14_2') {
				this.changetableval(
					'cwbbxqykjzz_3_19_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_14_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_15_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_16_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_17_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_18_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_15_1') {
				this.changetableval(
					'cwbbxqykjzz_3_19_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_14_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_15_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_16_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_17_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_18_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_15_2') {
				this.changetableval(
					'cwbbxqykjzz_3_19_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_14_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_15_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_16_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_17_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_18_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_16_1') {
				this.changetableval(
					'cwbbxqykjzz_3_19_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_14_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_15_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_16_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_17_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_18_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_16_2') {
				this.changetableval(
					'cwbbxqykjzz_3_19_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_14_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_15_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_16_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_17_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_18_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_17_1') {
				this.changetableval(
					'cwbbxqykjzz_3_19_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_14_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_15_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_16_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_17_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_18_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_17_2') {
				this.changetableval(
					'cwbbxqykjzz_3_19_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_14_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_15_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_16_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_17_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_18_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_18_1') {
				this.changetableval(
					'cwbbxqykjzz_3_19_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_14_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_15_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_16_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_17_1', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_18_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_18_2') {
				this.changetableval(
					'cwbbxqykjzz_3_19_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_14_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_15_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_16_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_17_2', 'tableDataV') -
						this.gettableval('cwbbxqykjzz_3_18_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_19_1') {
				this.changetableval(
					'cwbbxqykjzz_3_20_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_7_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_13_1', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_19_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_19_2') {
				this.changetableval(
					'cwbbxqykjzz_3_20_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_7_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_13_2', 'tableDataV') +
						this.gettableval('cwbbxqykjzz_3_19_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_20_1') {
				this.changetableval(
					'cwbbxqykjzz_3_22_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_20_1', 'tableDataV') + this.gettableval('cwbbxqykjzz_3_21_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_20_2') {
				this.changetableval(
					'cwbbxqykjzz_3_22_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_20_2', 'tableDataV') + this.gettableval('cwbbxqykjzz_3_21_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_21_1') {
				this.changetableval(
					'cwbbxqykjzz_3_22_1',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_20_1', 'tableDataV') + this.gettableval('cwbbxqykjzz_3_21_1', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_3_21_2') {
				this.changetableval(
					'cwbbxqykjzz_3_22_2',
					'tableDataV',
					this.gettableval('cwbbxqykjzz_3_20_2', 'tableDataV') + this.gettableval('cwbbxqykjzz_3_21_2', 'tableDataV')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_1_1') {
				this.cwbbxqykjzz_4_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_1_2') {
				this.cwbbxqykjzz_4_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_2_1') {
				this.cwbbxqykjzz_4_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_2_2') {
				this.cwbbxqykjzz_4_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_3_1') {
				this.cwbbxqykjzz_4_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_3_2') {
				this.cwbbxqykjzz_4_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_4_1') {
				this.cwbbxqykjzz_4_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_4_2') {
				this.cwbbxqykjzz_4_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_5_1') {
				this.cwbbxqykjzz_4_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_5_2') {
				this.cwbbxqykjzz_4_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_6_1') {
				this.cwbbxqykjzz_4_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_6_2') {
				this.cwbbxqykjzz_4_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_7_1') {
				this.cwbbxqykjzz_4_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_7_2') {
				this.cwbbxqykjzz_4_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_8_1') {
				this.cwbbxqykjzz_4_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_8_2') {
				this.cwbbxqykjzz_4_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_9_1') {
				this.cwbbxqykjzz_4_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_9_2') {
				this.cwbbxqykjzz_4_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_10_1') {
				this.cwbbxqykjzz_4_3_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_10_2') {
				this.cwbbxqykjzz_4_3_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_11_1') {
				this.cwbbxqykjzz_4_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_11_2') {
				this.cwbbxqykjzz_4_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_12_1') {
				this.changetableval(
					'cwbbxqykjzz_4_11_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_12_1', 'tableDataVI') + this.gettableval('cwbbxqykjzz_4_13_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_12_2') {
				this.changetableval(
					'cwbbxqykjzz_4_11_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_12_2', 'tableDataVI') + this.gettableval('cwbbxqykjzz_4_13_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_13_1') {
				this.changetableval(
					'cwbbxqykjzz_4_11_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_12_1', 'tableDataVI') + this.gettableval('cwbbxqykjzz_4_13_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_13_2') {
				this.changetableval(
					'cwbbxqykjzz_4_11_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_12_2', 'tableDataVI') + this.gettableval('cwbbxqykjzz_4_13_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_14_1') {
				this.cwbbxqykjzz_4_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_14_2') {
				this.cwbbxqykjzz_4_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_15_1') {
				this.changetableval(
					'cwbbxqykjzz_4_14_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_15_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_16_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_17_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_15_2') {
				this.changetableval(
					'cwbbxqykjzz_4_14_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_15_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_16_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_17_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_16_1') {
				this.changetableval(
					'cwbbxqykjzz_4_14_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_15_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_16_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_17_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_16_2') {
				this.changetableval(
					'cwbbxqykjzz_4_14_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_15_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_16_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_17_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_17_1') {
				this.changetableval(
					'cwbbxqykjzz_4_14_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_15_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_16_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_17_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_17_2') {
				this.changetableval(
					'cwbbxqykjzz_4_14_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_15_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_16_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_17_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_18_1') {
				this.cwbbxqykjzz_4_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_18_2') {
				this.cwbbxqykjzz_4_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_19_1') {
				this.changetableval('cwbbxqykjzz_4_18_1', 'tableDataVI', this.gettableval('cwbbxqykjzz_4_19_1', 'tableDataVI'));
			}
			if (e.cellCode == 'cwbbxqykjzz_4_19_2') {
				this.changetableval('cwbbxqykjzz_4_18_2', 'tableDataVI', this.gettableval('cwbbxqykjzz_4_19_2', 'tableDataVI'));
			}
			if (e.cellCode == 'cwbbxqykjzz_4_20_1') {
				this.cwbbxqykjzz_4_21_1();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_20_2') {
				this.cwbbxqykjzz_4_21_2();
			}
			if (e.cellCode == 'cwbbxqykjzz_4_21_1') {
				this.changetableval(
					'cwbbxqykjzz_4_30_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_21_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_22_1', 'tableDataVI') -
						this.gettableval('cwbbxqykjzz_4_24_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_21_2') {
				this.changetableval(
					'cwbbxqykjzz_4_30_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_21_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_22_2', 'tableDataVI') -
						this.gettableval('cwbbxqykjzz_4_24_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_22_1') {
				this.changetableval(
					'cwbbxqykjzz_4_30_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_21_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_22_1', 'tableDataVI') -
						this.gettableval('cwbbxqykjzz_4_24_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_22_2') {
				this.changetableval(
					'cwbbxqykjzz_4_30_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_21_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_22_2', 'tableDataVI') -
						this.gettableval('cwbbxqykjzz_4_24_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_23_1') {
				this.changetableval('cwbbxqykjzz_4_22_1', 'tableDataVI', this.gettableval('cwbbxqykjzz_4_23_1', 'tableDataVI'));
			}
			if (e.cellCode == 'cwbbxqykjzz_4_23_2') {
				this.changetableval('cwbbxqykjzz_4_22_2', 'tableDataVI', this.gettableval('cwbbxqykjzz_4_23_2', 'tableDataVI'));
			}
			if (e.cellCode == 'cwbbxqykjzz_4_24_1') {
				this.changetableval(
					'cwbbxqykjzz_4_30_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_21_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_22_1', 'tableDataVI') -
						this.gettableval('cwbbxqykjzz_4_24_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_24_2') {
				this.changetableval(
					'cwbbxqykjzz_4_30_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_21_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_22_2', 'tableDataVI') -
						this.gettableval('cwbbxqykjzz_4_24_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_25_1') {
				this.changetableval(
					'cwbbxqykjzz_4_24_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_25_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_26_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_27_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_28_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_29_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_25_2') {
				this.changetableval(
					'cwbbxqykjzz_4_24_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_25_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_26_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_27_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_28_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_29_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_26_1') {
				this.changetableval(
					'cwbbxqykjzz_4_24_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_25_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_26_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_27_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_28_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_29_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_26_2') {
				this.changetableval(
					'cwbbxqykjzz_4_24_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_25_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_26_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_27_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_28_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_29_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_27_1') {
				this.changetableval(
					'cwbbxqykjzz_4_24_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_25_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_26_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_27_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_28_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_29_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_27_2') {
				this.changetableval(
					'cwbbxqykjzz_4_24_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_25_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_26_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_27_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_28_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_29_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_28_1') {
				this.changetableval(
					'cwbbxqykjzz_4_24_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_25_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_26_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_27_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_28_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_29_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_28_2') {
				this.changetableval(
					'cwbbxqykjzz_4_24_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_25_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_26_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_27_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_28_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_29_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_29_1') {
				this.changetableval(
					'cwbbxqykjzz_4_24_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_25_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_26_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_27_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_28_1', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_29_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_29_2') {
				this.changetableval(
					'cwbbxqykjzz_4_24_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_25_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_26_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_27_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_28_2', 'tableDataVI') +
						this.gettableval('cwbbxqykjzz_4_29_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_30_1') {
				this.changetableval(
					'cwbbxqykjzz_4_32_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_30_1', 'tableDataVI') - this.gettableval('cwbbxqykjzz_4_31_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_30_2') {
				this.changetableval(
					'cwbbxqykjzz_4_32_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_30_2', 'tableDataVI') - this.gettableval('cwbbxqykjzz_4_31_2', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_31_1') {
				this.changetableval(
					'cwbbxqykjzz_4_32_1',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_30_1', 'tableDataVI') - this.gettableval('cwbbxqykjzz_4_31_1', 'tableDataVI')
				);
			}
			if (e.cellCode == 'cwbbxqykjzz_4_31_2') {
				this.changetableval(
					'cwbbxqykjzz_4_32_2',
					'tableDataVI',
					this.gettableval('cwbbxqykjzz_4_30_2', 'tableDataVI') - this.gettableval('cwbbxqykjzz_4_31_2', 'tableDataVI')
				);
			}
		},
		cwbbxqykjzz_0_15_1() {
			this.changetableval(
				'cwbbxqykjzz_0_15_1',
				'tableDataI',
				this.gettableval('cwbbxqykjzz_0_1_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_2_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_3_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_4_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_5_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_6_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_7_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_8_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_9_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_14_1', 'tableDataI')
			);
		},
		cwbbxqykjzz_0_15_2() {
			this.changetableval(
				'cwbbxqykjzz_0_15_2',
				'tableDataI',
				this.gettableval('cwbbxqykjzz_0_1_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_2_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_3_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_4_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_5_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_6_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_7_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_8_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_9_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_14_2', 'tableDataI')
			);
		},
		cwbbxqykjzz_0_29_1() {
			this.changetableval(
				'cwbbxqykjzz_0_29_1',
				'tableDataI',
				this.gettableval('cwbbxqykjzz_0_16_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_17_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_20_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_21_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_22_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_23_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_24_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_25_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_26_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_27_1', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_28_1', 'tableDataI')
			);
		},
		cwbbxqykjzz_0_29_2() {
			this.changetableval(
				'cwbbxqykjzz_0_29_2',
				'tableDataI',
				this.gettableval('cwbbxqykjzz_0_16_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_17_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_20_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_21_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_22_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_23_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_24_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_25_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_26_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_27_2', 'tableDataI') +
					this.gettableval('cwbbxqykjzz_0_28_2', 'tableDataI')
			);
		},
		cwbbxqykjzz_0_41_1() {
			this.changetableval(
				'cwbbxqykjzz_0_41_1',
				'tableDataci',
				this.gettableval('cwbbxqykjzz_0_31_1', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_32_1', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_33_1', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_34_1', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_35_1', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_36_1', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_37_1', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_38_1', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_39_1', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_40_1', 'tableDataci')
			);
		},
		cwbbxqykjzz_0_41_2() {
			this.changetableval(
				'cwbbxqykjzz_0_41_2',
				'tableDataci',
				this.gettableval('cwbbxqykjzz_0_31_2', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_32_2', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_33_2', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_34_2', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_35_2', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_36_2', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_37_2', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_38_2', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_39_2', 'tableDataci') +
					this.gettableval('cwbbxqykjzz_0_40_2', 'tableDataci')
			);
		},
		cwbbxqykjzz_1_7_1() {
			this.changetableval(
				'cwbbxqykjzz_1_7_1',
				'tableDataII',
				this.gettableval('cwbbxqykjzz_1_1_1', 'tableDataII') +
					this.gettableval('cwbbxqykjzz_1_2_1', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_3_1', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_4_1', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_5_1', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_6_1', 'tableDataII')
			);
		},
		cwbbxqykjzz_1_7_2() {
			this.changetableval(
				'cwbbxqykjzz_1_7_2',
				'tableDataII',
				this.gettableval('cwbbxqykjzz_1_1_2', 'tableDataII') +
					this.gettableval('cwbbxqykjzz_1_2_2', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_3_2', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_4_2', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_5_2', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_6_2', 'tableDataII')
			);
		},
		cwbbxqykjzz_1_13_1() {
			this.changetableval(
				'cwbbxqykjzz_1_13_1',
				'tableDataII',
				this.gettableval('cwbbxqykjzz_1_8_1', 'tableDataII') +
					this.gettableval('cwbbxqykjzz_1_9_1', 'tableDataII') +
					this.gettableval('cwbbxqykjzz_1_10_1', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_11_1', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_12_1', 'tableDataII')
			);
		},
		cwbbxqykjzz_1_13_2() {
			this.changetableval(
				'cwbbxqykjzz_1_13_2',
				'tableDataII',
				this.gettableval('cwbbxqykjzz_1_8_2', 'tableDataII') +
					this.gettableval('cwbbxqykjzz_1_9_2', 'tableDataII') +
					this.gettableval('cwbbxqykjzz_1_10_2', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_11_2', 'tableDataII') -
					this.gettableval('cwbbxqykjzz_1_12_2', 'tableDataII')
			);
		},
		cwbbxqykjzz_2_3_1() {
			this.changetableval(
				'cwbbxqykjzz_2_3_1',
				'tableDataIII',
				this.gettableval('cwbbxqykjzz_2_4_1', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_5_1', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_6_1', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_7_1', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_8_1', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_9_1', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_10_1', 'tableDataIII')
			);
		},
		cwbbxqykjzz_2_3_2() {
			this.changetableval(
				'cwbbxqykjzz_2_3_2',
				'tableDataIII',
				this.gettableval('cwbbxqykjzz_2_4_2', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_5_2', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_6_2', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_7_2', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_8_2', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_9_2', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_10_2', 'tableDataIII')
			);
		},
		cwbbxqykjzz_2_21_1() {
			this.changetableval(
				'cwbbxqykjzz_2_21_1',
				'tableDataIII',
				this.gettableval('cwbbxqykjzz_2_1_1', 'tableDataIII') -
					this.gettableval('cwbbxqykjzz_2_2_1', 'tableDataIII') -
					this.gettableval('cwbbxqykjzz_2_3_1', 'tableDataIII') -
					this.gettableval('cwbbxqykjzz_2_11_1', 'tableDataIII') -
					this.gettableval('cwbbxqykjzz_2_14_1', 'tableDataIII') -
					this.gettableval('cwbbxqykjzz_2_18_1', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_20_1', 'tableDataIII')
			);
		},
		cwbbxqykjzz_2_21_2() {
			this.changetableval(
				'cwbbxqykjzz_2_21_2',
				'tableDataIII',
				this.gettableval('cwbbxqykjzz_2_1_2', 'tableDataIII') -
					this.gettableval('cwbbxqykjzz_2_2_2', 'tableDataIII') -
					this.gettableval('cwbbxqykjzz_2_3_2', 'tableDataIII') -
					this.gettableval('cwbbxqykjzz_2_11_2', 'tableDataIII') -
					this.gettableval('cwbbxqykjzz_2_14_2', 'tableDataIII') -
					this.gettableval('cwbbxqykjzz_2_18_2', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_20_2', 'tableDataIII')
			);
		},
		cwbbxqykjzz_2_24_1() {
			this.changetableval(
				'cwbbxqykjzz_2_24_1',
				'tableDataIII',
				this.gettableval('', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_26_1', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_27_1', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_28_1', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_29_1', 'tableDataIII')
			);
		},
		cwbbxqykjzz_2_24_2() {
			this.changetableval(
				'cwbbxqykjzz_2_24_2',
				'tableDataIII',
				this.gettableval('cwbbxqykjzz_2_25_2', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_26_2', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_27_2', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_28_2', 'tableDataIII') +
					this.gettableval('cwbbxqykjzz_2_29_2', 'tableDataIII')
			);
		},
		cwbbxqykjzz_3_7_1() {
			this.changetableval(
				'cwbbxqykjzz_3_7_1',
				'tableDataV',
				this.gettableval('cwbbxqykjzz_3_1_1', 'tableDataV') +
					this.gettableval('cwbbxqykjzz_3_2_1', 'tableDataV') -
					this.gettableval('cwbbxqykjzz_3_3_1', 'tableDataV') -
					this.gettableval('cwbbxqykjzz_3_4_1', 'tableDataV') -
					this.gettableval('cwbbxqykjzz_3_5_1', 'tableDataV') -
					this.gettableval('cwbbxqykjzz_3_6_1', 'tableDataV')
			);
		},
		cwbbxqykjzz_3_7_2() {
			this.changetableval(
				'cwbbxqykjzz_3_7_2',
				'tableDataV',
				this.gettableval('cwbbxqykjzz_3_1_2', 'tableDataV') +
					this.gettableval('cwbbxqykjzz_3_2_2', 'tableDataV') -
					this.gettableval('cwbbxqykjzz_3_3_2', 'tableDataV') -
					this.gettableval('cwbbxqykjzz_3_4_2', 'tableDataV') -
					this.gettableval('cwbbxqykjzz_3_5_2', 'tableDataV') -
					this.gettableval('cwbbxqykjzz_3_6_2', 'tableDataV')
			);
		},
		cwbbxqykjzz_4_21_1() {
			this.changetableval(
				'cwbbxqykjzz_4_21_1',
				'tableDataVI',
				this.gettableval('cwbbxqykjzz_4_1_1', 'tableDataVI') -
					this.gettableval('cwbbxqykjzz_4_2_1', 'tableDataVI') -
					this.gettableval('cwbbxqykjzz_4_3_1', 'tableDataVI') -
					this.gettableval('cwbbxqykjzz_4_11_1', 'tableDataVI') -
					this.gettableval('cwbbxqykjzz_4_14_1', 'tableDataVI') -
					this.gettableval('cwbbxqykjzz_4_18_1', 'tableDataVI') +
					this.gettableval('cwbbxqykjzz_4_20_1', 'tableDataVI')
			);
		},
		cwbbxqykjzz_4_21_2() {
			this.changetableval(
				'cwbbxqykjzz_4_21_2',
				'tableDataVI',
				this.gettableval('cwbbxqykjzz_4_1_2', 'tableDataVI') -
					this.gettableval('cwbbxqykjzz_4_2_2', 'tableDataVI') -
					this.gettableval('cwbbxqykjzz_4_3_2', 'tableDataVI') -
					this.gettableval('cwbbxqykjzz_4_11_2', 'tableDataVI') -
					this.gettableval('cwbbxqykjzz_4_14_2', 'tableDataVI') -
					this.gettableval('cwbbxqykjzz_4_18_2', 'tableDataVI') +
					this.gettableval('cwbbxqykjzz_4_20_2', 'tableDataVI')
			);
		},
		cwbbxqykjzz_4_3_1() {
			this.changetableval(
				'cwbbxqykjzz_4_3_1',
				'tableDataVI',
				this.gettableval('cwbbxqykjzz_4_4_1', 'tableDataV') +
					this.gettableval('cwbbxqykjzz_4_5_1', 'tableDataVI') +
					this.gettableval('cwbbxqykjzz_4_6_1', 'tableDataV') +
					this.gettableval('cwbbxqykjzz_4_7_1	', 'tableDataVI') +
					this.gettableval('cwbbxqykjzz_4_8_1', 'tableDataV') +
					this.gettableval('cwbbxqykjzz_4_9_1', 'tableDataVI') +
					this.gettableval('cwbbxqykjzz_4_10_1', 'tableDataV')
			);
		},
		cwbbxqykjzz_4_3_2() {
			this.changetableval(
				'cwbbxqykjzz_4_3_2',
				'tableDataVI',
				this.gettableval('cwbbxqykjzz_4_4_2', 'tableDataV') +
					this.gettableval('cwbbxqykjzz_4_5_2', 'tableDataVI') +
					this.gettableval('cwbbxqykjzz_4_6_2', 'tableDataV') +
					this.gettableval('cwbbxqykjzz_4_7_2	', 'tableDataVI') +
					this.gettableval('cwbbxqykjzz_4_8_2', 'tableDataV') +
					this.gettableval('cwbbxqykjzz_4_9_2', 'tableDataVI') +
					this.gettableval('cwbbxqykjzz_4_10_2', 'tableDataV')
			);
		},
		gettableval(changecode, table, old) {
			var head = '';
			if (table == 'tableDataI' || table == 'tableDataci') {
				head = 'ZeroHead';
			}
			if (table == 'tableDataII') {
				head = 'IHead';
			}
			if (table == 'tableDataIII') {
				head = 'IIHead';
			}
			if (table == 'tableDataVI') {
				head = 'IIIHead';
			}
			if (table == 'tableDataV') {
				head = 'IVHead';
			}
			var a;
			if (this[table] && this[head]) {
				for (let i = 0; i < this[table].length; i++) {
					for (let j = 0; j < this[head].length; j++) {
						if (
							this[table][i][this[head][j]] &&
							this[table][i][this[head][j]].cellCode &&
							this[table][i][this[head][j]].cellVal &&
							this[table][i][this[head][j]].cellCode == changecode
						) {
							if (old) {
								if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
									a = 0;
								} else {
									a = parseFloat(this[table][i][this[head][j]].goujgxValue);
								}
							} else {
								if (this[table][i][this[head][j]].cellVal == '- -') {
									a = 0;
								} else {
									a = parseFloat(this[table][i][this[head][j]].cellVal || 0);
								}
							}
							break;
						}
					}
				}
			}
			a = a || 0;
			return a;
		},
		changetableval(changecode, table, newval, checkq) {
			var newval = newval || 0;
			newval = this.toFixed(newval, 2);
			var head = '';
			if (table == 'tableDataI' || table == 'tableDataci') {
				head = 'ZeroHead';
			}
			if (table == 'tableDataII') {
				head = 'IHead';
			}
			if (table == 'tableDataIII') {
				head = 'IIHead';
			}
			if (table == 'tableDataVI') {
				head = 'IIIHead';
			}
			if (table == 'tableDataV') {
				head = 'IVHead';
			}
			for (let i = 0; i < this[table].length; i++) {
				for (let j = 0; j < this[head].length; j++) {
					if (
						this[table][i][this[head][j]] &&
						this[table][i][this[head][j]].cellCode &&
						typeof this[table][i][this[head][j]].cellVal != 'undefined' &&
						typeof this[table][i][this[head][j]].cellVal != undefined &&
						this[table][i][this[head][j]].cellCode == changecode
					) {
						if (this[table][i][this[head][j]].cellVal != newval) {
							if (this.suosq.substring(4, 6) < 5 && checkq) {
								this[table][i][this[head][j]].cellVal = '';
							} else {
								this[table][i][this[head][j]].cellVal = newval + '';
							}
							this.inputblur({
								cellCode: changecode,
								cellVal: newval
							});
							break;
						}
					}
				}
			}
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
